module.exports = function() {
  return new Worker(__webpack_public_path__ + "e2b004f4b1af6867979d.worker.js");
};